import { Group, Text } from '@mantine/core'
import { IconGlobe } from 'components/icons/IconGlobe'
import { IconHistory } from 'components/icons/IconHistory'
import { IconOrganization } from 'components/icons/IconOrganization'
import { IconProperty } from 'components/icons/IconProperty'
import type { TSearchResultsItem } from '../types'

export const AutoCompleteItem = ({ type, label }: Pick<TSearchResultsItem, 'type' | 'label'>) => (
  <Group wrap="nowrap">
    <Text component="div" css={{ display: 'flex', alignItems: 'center' }}>
      <div css={{ width: 36, display: 'inline-block' }}>
        {type === 'PROPERTY' && <IconProperty />}
        {type === 'ORGANIZATION' && <IconOrganization />}
        {type === 'COUNTRY' && <IconGlobe />}
        {type === 'ADMINISTRATIVE_AREA_LEVEL_1' && <IconGlobe />}
        {type === 'PREVIOUS_SEARCH' && <IconHistory />}
      </div>
      <div css={{ flex: 1 }}>{label}</div>
    </Text>
  </Group>
)
